import React from "react"

export default function PlasticIcon({ image }) {
  return (
    <div className="p-2 bg-white">
      <img src={image} className="w-20 h-20" />
    </div>
  )
}
